import React from "react";
import { Link } from "../../../utils/customLink";

import Image from "../../image";

const YourImpact = ({ yourImpact, locations }) => {
  const theHub = yourImpact?.impactContent
    ?.reduce((acc, item) => {
      const impactLocations =
        item?.impactHubLocation?.flatMap(
          (hub) => hub?.geographical?.nodes ?? []
        ) ?? [];

      const isLocationIncluded = impactLocations.some((hubLocation) =>
        hubLocation.slug?.includes(locations)
      );
      if (isLocationIncluded) acc = [item]; // Keep the last matching item
      return acc;
    }, [])
    ?.shift();

  return (
    <>
      <h2
        className="heading text-left py-5"
        dangerouslySetInnerHTML={{ __html: yourImpact?.yourImpactTitle }}
      />

      <div className="divide-y width-divider" />

      <div
        className="planet:gvi-light-gray-text text-black-lighter text-sm pt-5 tab-content_html"
        dangerouslySetInnerHTML={{ __html: yourImpact?.impactIntro }}
      />

      <Image
        imageClass={"w-full object-contain object-center rounded-md my-5"}
        imageAlt={""}
        image={yourImpact?.impactSdgImage?.localFile}
        sourceUrl={yourImpact?.impactSdgImage?.sourceUrl}
      />

      <div
        className="planet:gvi-light-gray-text text-black-lighter text-sm pt-5 tab-content_html"
        dangerouslySetInnerHTML={{ __html: theHub?.impactSdgContent }}
      />

      {theHub && theHub?.ourPartners && (
        <>
          <h3 className="heading text-left py-3">Our partners</h3>
          <div className="partners-logos grid grid-cols-2 grid-rows-2 gap-4 py-3">
            {theHub &&
              theHub?.ourPartners &&
              theHub?.ourPartners?.map((partner, idx) => (
                <div
                  key={`$impact-key-${idx}`}
                  className={
                    "shadow-lg planet:shadow-none rounded-md w-full flex items-center justify-center bg-white h-44 col-span-2 row-span-1 sm:col-span-1 sm:row-span-2"
                  }
                >
                  <Image
                    imageClass={"h-24"}
                    imageAlt={""}
                    image={partner?.partnerLogo?.localFile}
                    sourceUrl={partner?.partnerLogo?.sourceUrl}
                  />
                </div>
              ))}
          </div>
        </>
      )}

      {theHub?.projectObjectives && (
        <>
          <h3 className="heading text-left pt-8 !pb-0">Project objectives</h3>
          <div
            className="planet:gvi-light-gray-text text-black-lighter  text-sm pb-5 tab-content_html"
            dangerouslySetInnerHTML={{ __html: theHub.projectObjectives }}
          />
        </>
      )}
    </>
  );
};

export default YourImpact;
